import { useLocation } from 'react-router-dom';
import { useLayoutEffect } from 'react';

const SITE_ORIGIN = 'https://co-labhealth.com';

function normalizeCanonicalPath(pathname) {
  if (!pathname || pathname === '/') return '/';
  // Canonicalize: remove trailing slash so `/login/` and `/login` match.
  if (pathname.endsWith('/')) return pathname.slice(0, -1);
  return pathname;
}

function upsertLinkCanonical(href) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = href;
}

function upsertMeta(nameOrProp, selectorValue, content, isProperty) {
  const selector = isProperty
    ? `meta[property="${selectorValue}"]`
    : `meta[name="${selectorValue}"]`;
  let meta = document.querySelector(selector);
  if (!meta) {
    meta = document.createElement('meta');
    if (isProperty) meta.setAttribute('property', selectorValue);
    else meta.setAttribute('name', selectorValue);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

const SeoCanonical = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    const path = normalizeCanonicalPath(location.pathname);
    const canonicalUrl = `${SITE_ORIGIN}${path}`;

    // Canonical
    upsertLinkCanonical(canonicalUrl);

    // Social URLs (not as important as <link rel="canonical">, but kept consistent)
    upsertMeta('property', 'og:url', canonicalUrl, true);
    upsertMeta('name', 'twitter:url', canonicalUrl, false);
    upsertMeta('name', 'twitter:site', '@colabhealth', false);

    // Titles/description per-route is handled by content; keep this change scoped to URLs.
  }, [location.pathname]);

  return null;
};

export default SeoCanonical;

